<template>
	<div class="margin-left">
		<div class="width920">
			<div>
				<div class="bg-white padding-lr-sm padding-bottom-sm padding-top radius top">
					<div class="text-32 text-000 text-bold padding-bottom-sm padding-top solid-bottom text-left">{{title}}</div>
					<div class="flex justify-between align-center">
						<div class="margin-top-sm">
							<div class="flex align-center justify-between">
								<p class="flex align-center">
									<img :src="avatar" class="block-30">
									<span class="text-sm text-333 margin-left-xs" v-if="company||userinfo">{{company.name||userinfo.nick_name}}</span>
								</p>
								<!-- <div class="flex align-center margin-left-xs">
									<img v-if="userinfo.is_real == 2" class="" src="https://manage.ciiply.com/web/static/home/authentication.png"  style="width: 16px;height: 20px;" >
									<img v-if="userinfo.is_real_company == 2" class="" src="https://manage.ciiply.com/web/static/home/enterprise.png"  style="width: 16px;height: 20px;" >
									<img v-else class="" src="https://manage.ciiply.com/web/static/home/random.png"  style="width: 16px;height: 20px;" >
									<p class="text-sm text-theme margin-left-xs" >{{userinfo.is_real_company == 2?'企业已认证':userinfo.is_real == 2?'个人已认证':'未认证'}}</p>
								</div> -->
							</div>
							<div class="flex align-center justify-between margin-top-xs">
								<p>
									<i class="el-icon-location-outline"></i>
									<span class="text-sm text-666">{{area}}</span>
								</p>
								<p class="flex align-center margin-left-sm">
									<span class="text-sm text-999">待遇</span>
									<span class="text-prices fs24">{{salary}}<span v-if="salary != '面议'">元/月</span></span>
								</p>
							</div>
						</div>
						<!-- 正在招 -->
						<div class="flex align-center" v-if="status == 1">
							<div class="margin-right-sm flex align-center justify-center pointer" @click="edit">
								<img class="call-icon" src="../../../assets/img/recruit/handle.png" >
								<p class=" text-theme">去修改</p>
							</div>
							<div class="full flex align-center justify-center pointer" @click="recruit">
								<p class="text-white">已招满</p>
							</div>
							<div class="callbtns flex align-center justify-center margin-left-xs pointer" @click="setop">
								<img class="insta" src="../../../assets/img/recruit/insta.png" >
								<p class="text-white margin-left-xs">设置置顶</p>
							</div>
						</div>
						<!-- 已招满 -->
						<div class="flex align-center" v-if="status == 3">
							<div @click="del" class="colt flex align-center justify-center pointer">
								<p class="text-666">删除</p>
							</div>
							<div @click="recovery" class="callbtns flex align-center justify-center margin-left-xs pointer">
								<img class="insta" src="../../../assets/img/recruit/insta.png" >
								<p class="text-white margin-left-xs">恢复招聘</p>
							</div>
						</div>
						<!-- 未通过 -->
						<div class="flex align-center" v-if="status == 2">
							<div @click="del" class="colt flex align-center justify-center pointer">
								<p class="text-999">删除</p>
							</div>
							<div @click="edit" class="callbtns flex align-center justify-center margin-left-xs pointer">
								<img class="insta" src="../../../assets/img/recruit/insta.png" >
								<p class="text-white margin-left-xs">修改信息</p>
							</div>
						</div>
					</div>
					<p v-if="status == 1" class="btn enrol text-theme">正在招</p>
				</div>
				<div class="failed flex align-center padding-tb-sm padding-lr-sm margin-top" v-if="status == 2">
					<p class="text-bold text-prices text-lg">未通过原因</p>
					<p class="reason margin-left-sm text-lg">{{reason}}</p>
				</div>
				<div class="bg-white margin-top padding-sm radius">
					<p class="title text-left padding-left-sm">职位详情</p>
					<div class="flex align-center margin-top-xs">
						<p v-for="(item,index) in category" :key="index" class="tip text-sm text-666 margin-right-xs">{{item.work_categroy_name}}工种</p>
						<p class="tip text-sm text-666 margin-right-xs">{{settlement}}</p>
						<p class="tip text-sm text-666 margin-right-xs">{{experience}}经验</p>
					</div>
				</div>
				<!-- <div class="bg-white margin-top padding-sm radius" v-if="company.content">
					<p class="title text-left padding-left-sm">{{company.content}}</p>
					
				</div> -->
				<!-- <div class="bg-white margin-top padding-sm radius">
					<p class="title text-left padding-left-sm">工作位置</p>
					 <div class="txMap margin-top-sm">
					    <div id="allmap"></div>
					  </div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		components: {
		},
		name: '',
		data() {
			return {
				latitude: 39.92855,//经纬度
				longitude: 116.41637,//经纬度
				title:'',//标题
				id:'',//id
				area:'',//地区
				settlement:'',//结算方式
				experience:'',//经验
				salary:'',//薪资
				content:'',//职位详情
				userinfo:null,//用户信息
				company:null,//企业信息
				workid:'',//工作id
				category:[],//工种
				type: 0,
				status:0,
				covers:[],
				reason:null,
				avatar:'',//头像
				is_top:0,//
			}
		},
		created() {
			Bus.$on('detailid',(data)=>{
				this.id = data
				this.getdetail()
			})
		},
		destroyed() {
			Bus.$off('detailid')
		},
		mounted () {
		    
		},
		methods: {
			back(){
				this.$router.back()
			},
			getdetail(){
				this.ajax('get', '/api/pc/work/getMyWorkInfo', {
				  id:this.id
				},res => {
					this.title = res.data.title
					this.area = res.data.area
					this.latitude = res.data.lat
					this.longitude = res.data.lng
					this.settlement = res.data.settlement
					this.experience = res.data.experience
					this.content = res.data.content
					this.salary = res.data.salary
					this.status = res.data.status
					this.userinfo = res.data.user
					this.avatar = res.data.avatar
					this.coll = res.data.coll
					this.reason = res.data.reason
					this.phone_num = res.data.user&&res.data.user.phone
					this.company = res.data.real_company
					this.is_top = res.data.is_top
					this.category = res.data.category
					// this.initMap2()
				})
			},
			//初始化渲染地图
			 initMap2 () {
			   //    console.log("window", window);
			   //    // 定义地图中心点坐标
			   //    let center = new TMap.LatLng(39.906632, 116.413306);// 坐标靠近中间
			   //    // 定义map变量，调用 TMap.Map() 构造函数创建地图
			   //    var map = new TMap.Map(document.getElementById("allmap"), {
			   //      center: center,
			   //      zoom: 15
			   //    });
			   //    //   //初始marker
			   //    var marker = new TMap.MultiMarker({
			   //      id: 'marker-layer',
			   //      map: map,
			   //      styles: {
			   //        // mark样式
			   //        "marker": new TMap.MarkerStyle({
			   //          "width": 25,
			   //          "height": 38,
			   //          "anchor": { x: 12, y: 32 },
			   //        })
			   //      },
			   //      geometries: [{
			   //        "id": 'demo1',
			   //        "styleId": 'marker',
			   //        "position": new TMap.LatLng(39.906632, 116.413306),
			   //        "properties": {
			   //          "title": "北京市东城区台基厂头条3号(王府井地铁站C3西南口步行470米)",
			   //          "address": "",
			   //        }
			   //      }]
			   //    });
			   //    //初始化infoWindow
			   //    var infoWindow = new TMap.InfoWindow({
			   //      map: map,
			   //      position: new TMap.LatLng(39.906632, 116.413306),
			   //      offset: { x: 0, y: -32 }, //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
			   //    });
			   //    // infoWindow.close();//初始关闭信息窗关闭
				  // console.log(marker);
				  // let add = marker.geometries[0]
				  // infoWindow.open(); //打开信息窗
				  // infoWindow.setPosition(add.position);//设置信息窗位置
				  // infoWindow.setContent(`<div style="white-space:
				  //   nowrap;margin:10px;color:#000;text-align:left;"> 
				  //   <p style="font-size:16px;">${add.properties.title}</p>
				  //    </div>`);//设置信息窗内容
			   //    //监听标注点击事件
			   //    marker.on("click", function (evt) {
			   //      console.log(evt)
			   //      //设置infoWindow
			   //      infoWindow.open(); //打开信息窗
			   //      infoWindow.setPosition(evt.geometry.position);//设置信息窗位置
			   //      infoWindow.setContent(`<div style="white-space:
			   //        nowrap;margin:10px;color:#000;text-align:left;"> 
			   //        <p style="font-size:16px;">${evt.geometry.properties.title}</p>
			   //         </div>`);//设置信息窗内容
			   //    })
			    },
			//删除
			del(){
				this.ajax('get', '/api/pc/work/delWork', {
					id:this.id,
				},res => {
					
				})
			},
			//已招满
			recruit(){
				this.ajax('post', '/api/pc/work/editWork', {
					id:this.id,
					status:3
				},res => {
					this.$message(res.msg);
					if(res.status == 200){
						this.getdetail()
					}else{
						
					}
				})
			},
			//恢复招聘
			recovery(){
				this.ajax('post', '/api/pc/work/editWork', {
					id:this.id,
					status:1
				},res => {
					this.$message(res.msg);
					if(res.status == 200){
						this.getdetail()
					}else{
						
					}
				})
			},
			edit(){
				let id = this.id
				let typeq = {
					type:'release',
					typeone:''
				}
				this.$emit('gettype',typeq)
				setTimeout(() => {
				     Bus.$emit('edit',id)
				   }, 20);
			},
			setop(){
				let typeq = {
					type:'setplacement',
					typeone:''
				}
				this.$emit('gettype',typeq)
				
				setTimeout(() => {
					let info = {
						type:0,
						id:this.id
					}
				     Bus.$emit('setplacement',info)
				   }, 20);
			}
		}
	}
</script>

<style scoped lang="less">
	.width920{
		width: 920px;
	}
	.text-32{
		font-size: 32px;
	}
	.fs24{
		font-size: 24px;
	}
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';
			
		}
	}
	//状态按钮
	.top{
		position: relative;
		.btn{
			position: absolute;
			top: 0;
			right: 0;
			width: 63px;
			height: 29px;
			line-height: 29px;
			border-radius: 0px 20px 0px 10px;
		}
		.enrol{
			background: #E6F2F2;
		}
	}
	//状态按钮 end
	//未通过原因 start
	.failed{
		background: #F4DFE0;
		border-radius: 20px;
		
	}
	//未通过原因 end
	.block-30{
		width: 30px;
		height: 30px;
		border-radius: 50%;
	}
	.colt{
		width: 111px;
		height: 45px;
		background: #FFFFFF;
		border: 1px solid #E6E6E6;
		border-radius: 23px;
	}
	.tip{
		padding: 12px 28px;
		background: #FFFFFF;
		box-shadow: 0px 5px 29px 2px rgba(204,204,204,0.3000);
		border-radius: 20px;
	}
	.full{
		width: 112px;
		height: 46px;
		left: 46px;
		background: #268AED;
		box-shadow: 0px 5px 29px 2px rgba(219,226,232,0.3);
		border-radius: 23px;
	}
	.callbtns{
		width: 193px;
		height: 45px;
		background: #0B837C;
		border-radius: 23px;
		.call-icon{
			width: 19px;
			height: 19px;
		}
		.insta{
			width: 20px;
			height: 24px;
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/components/my/recruit/detail.vue